import { useState } from "react";
import { Download, Loader2 } from "lucide-react";

const PDF_URL = "/wadeemgardens.pdf";
const FILE_NAME = "WadeemGardensReport.pdf";
const PAGES = [1, 2, 3, 4, 5, 6, 7, 8, 9];

export default function WadeemGardens() {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      setDownloading(true);
      const res = await fetch(PDF_URL);
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = FILE_NAME;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      window.open(PDF_URL, "_blank");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div data-testid="wadeemgardens-page" className="min-h-screen bg-[#0A1B33]">
      <header className="sticky top-0 z-20 flex items-center justify-between gap-3 px-4 py-3 bg-[#0A1B33]/95 backdrop-blur border-b border-white/10">
        <span
          data-testid="wadeemgardens-title"
          className="text-white font-semibold tracking-wide text-sm sm:text-base"
        >
          Wadeem Gardens — Report
        </span>
        <button
          data-testid="wadeemgardens-download-btn"
          onClick={handleDownload}
          disabled={downloading}
          className="inline-flex items-center gap-2 rounded-full bg-[#C9A24B] hover:bg-[#b8913c] disabled:opacity-70 text-[#0A1B33] font-medium px-4 py-2 text-sm transition-colors"
        >
          {downloading ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
          {downloading ? "Bezig…" : "Download PDF"}
        </button>
      </header>

      <main className="mx-auto max-w-3xl px-2 sm:px-4 py-4 sm:py-6">
        <div className="flex flex-col gap-3 sm:gap-4">
          {PAGES.map((n) => (
            <img
              key={n}
              data-testid={`wadeemgardens-page-${n}`}
              src={`/wadeemgardens/page-${n}.jpg`}
              alt={`Wadeem Gardens report — pagina ${n}`}
              loading={n <= 2 ? "eager" : "lazy"}
              className="w-full h-auto rounded-lg shadow-2xl bg-white"
            />
          ))}
        </div>

        <div className="mt-6 mb-10 text-center">
          <button
            data-testid="wadeemgardens-download-btn-bottom"
            onClick={handleDownload}
            disabled={downloading}
            className="inline-flex items-center gap-2 rounded-full bg-[#C9A24B] hover:bg-[#b8913c] disabled:opacity-70 text-[#0A1B33] font-semibold px-6 py-3 text-sm transition-colors"
          >
            {downloading ? <Loader2 size={18} className="animate-spin" /> : <Download size={18} />}
            {downloading ? "Bezig…" : "Download het volledige rapport (PDF)"}
          </button>
        </div>
      </main>
    </div>
  );
}
